import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import 'typeface-muli';
import './i18n';
import './react-chartjs-2-defaults';
import './styles/index.css';

import App from 'app/App';
import ErrorHandling from 'app/ErrorHandling';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
	<ErrorHandling>
		<App />
	</ErrorHandling>,
	document.getElementById('root')
);

// The public web-chat page registers its own worker (public/webchat-sw.js) so that
// Android can show message notifications; this cleanup would unregister it the
// moment it became ready.
if (window.location.pathname !== '/apps/whatsapp') {
	serviceWorker.unregister();
}
